

import BaseSection from "@/components/base/BaseSection.vue";
import { defineComponent } from "vue";

export default defineComponent({
	name: "TripAmendmentHeader",
	props: {
		isAmendment: Boolean
	},
	setup() {
		return { };
	},
	components: {
		BaseSection
	}
});
